import React from 'react';
import { useAppSelector } from '../../store/hooks';
import Header from './Header';
import Sidebar from './Sidebar';
import NotificationContainer from '../UI/NotificationContainer';
import { ChatBot } from '../ChatBot';

interface LayoutProps {
  children: React.ReactNode;
  hideHeader?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, hideHeader = false }) => {
  const { sidebarOpen, theme } = useAppSelector((state) => state.ui);

  return (
    <div className={`min-h-screen w-full max-w-full overflow-x-hidden transition-all duration-300 ${
      theme === 'dark' ? 'bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900' : 'bg-gray-50'
    }`}>
      {/* Header */}
      {!hideHeader && <Header />}
      
      {/* Spacer div to account for fixed header - ensures consistent layout */}
      {!hideHeader && <div className="h-14 sm:h-16" aria-hidden="true" />}
      
      <div className="flex">
        {/* Sidebar */}
        <Sidebar />
        
        {/* Main Content */}
        <main className={`flex-1 w-0 min-w-0 transition-all duration-300 ease-in-out ${
          sidebarOpen ? 'lg:ml-60' : 'lg:ml-16'
        }`}>
          <div className="w-full max-w-full px-3 sm:px-4 lg:px-6 py-1 overflow-x-hidden">
            {children}
          </div>
        </main>
      </div>
      
      {/* Notifications */}
      <NotificationContainer />
      
      {/* ChatBot (visible in all environments) */}
      <ChatBot />
    </div>
  );
};

export default Layout;
